module.exports = __webpack_public_path__ + "img/tin-can-stories.24b43bef.png";